// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sweetalert-confirm-button {
    color: white !important; /* Change text color to black */
    background-color: black; /* Optional: Adjust the button background color */
    border: 1px solid black; /* Optional: Add a border to make it visible */
  }`, "",{"version":3,"sources":["webpack://./src/components/jupyton.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB,EAAE,+BAA+B;IACxD,uBAAuB,EAAE,iDAAiD;IAC1E,uBAAuB,EAAE,8CAA8C;EACzE","sourcesContent":[".sweetalert-confirm-button {\n    color: white !important; /* Change text color to black */\n    background-color: black; /* Optional: Adjust the button background color */\n    border: 1px solid black; /* Optional: Add a border to make it visible */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
